export default {
  getPostByName: (state) => (inputValue) => {
    return state.posts.filter(post => {
      var result = post.postName
      return result.match(inputValue)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/belongModules/getters.js